module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_add-to-unscopables.js
// module id = 208
// module chunks = 1